module.exports = __webpack_public_path__ + "static/banner-f9635af9d54ec374d21d4bcf86ddd754.png";